<template>
  <div>
    <b-dropdown
      id="dropdown-save-selection-as"
      text="Save selection: "
      toggle-class="btn-primary"
      class="float-right mb-2"
      variant="primary"
      size="sm"
    >
      <b-dropdown-item
        v-if="!themeSelected"
        class="warning"
        @click.prevent="warnIfNoThemeSelected"
      >
        As theme image
        <span class="text-muted">please select theme</span>
      </b-dropdown-item>
      <b-dropdown-item
        v-else-if="isSavableToTheme"
        @click.prevent="saveToTheme"
      >
        As theme image
      </b-dropdown-item>
      <b-dropdown-item 
        v-if="isDownloadable"
        @click.prevent="downloadFromBrowser"
      >
        Download 
      </b-dropdown-item>
    </b-dropdown>
    <div
      v-if="showFilenamePrompt" 
      class="custom-popup"
    >
      <div class="custom-popup-content">
        <h5>Enter File Name</h5>
        <b-form-input
          v-model="tempFileName" 
          placeholder="Enter filename..."
        />
        <b-form-checkbox 
          v-model="replaceExistingImage" 
          class="mt-2 d-none"
        >
          Replace existing image
        </b-form-checkbox>
        
        <div class="mt-3 d-flex justify-content-end">
          <b-button
            variant="secondary"
            class="mr-2"
            @click="cancelFileName"
          >
            Cancel
          </b-button>
          <b-button
            variant="primary"
            :disabled="!tempFileName.trim()"
            @click="confirmFileName"
          >
            OK
          </b-button>
        </div>
      </div>
      <div class="custom-popup-backdrop" />
    </div>
  </div>
</template>

<script>


import {
  saveSelectionAsEventBroker,
  EVENTS,
} from "@frontend/group/modules/save-selection-as/event-broker";
import { mapGetters } from 'vuex'
import { TOOL } from "@frontend/group/modules/save-selection-as/constants";


const TOOLS_MAPPINGS = {
  'btn-modal-save-selection': TOOL.CROP,
  'btn-modal-save-fade-image': TOOL.FADE,
  'btn-save-result-magick-eraser-in-theme': TOOL.PAINT_BRUSH,
  'btn-save-result-painbucket-in-theme': TOOL.PAINT_BUCKET,
  'btn-save-result-replace-color-in-theme': TOOL.REPLACE_COLOR,
  'btn-save-result-hue-saturation-in-theme': TOOL.HUE_SATURATION,
  'btn-save-result-ai-edit-in-theme': TOOL.AI
};
export default {
  name: 'BtnSaveSelectionAs',
  props: {
    saveButtonClass: {
      type: [String],
      default: null,
    },
    selectedThemeId: {
      type: [Number, String],
      default: null,
    },
    fileName: {
      type: String,
      default: null,
    },
    imagePath: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      resolveFileNamePromise: null,
      tempFileName: '',
      showFilenamePrompt: false,
      replaceExistingImage: false,
    };
  },
  computed: {
    ...mapGetters('layout', [
      'selectedInstance',
    ]),
    
    themeSelected() {
      
      return this.selectedInstance?.data?.theme;
    },
    isDownloadable() {
      return [
        'btn-modal-save-selection',
        'btn-save-result-painbucket-in-theme',
        'btn-modal-save-fade-image',
        'btn-save-result-magick-eraser-in-theme',
        'btn-save-result-hue-saturation-in-theme',
        'btn-save-result-replace-color-in-theme',
        'btn-save-result-ai-edit-in-theme'
      ].includes(this.saveButtonClass);
    },
    isSavableToTheme() {
      return [
        'btn-save-result-painbucket-in-theme',
        'btn-modal-save-fade-image',
        'btn-save-result-magick-eraser-in-theme',
        'btn-save-result-hue-saturation-in-theme',
        'btn-save-result-replace-color-in-theme',
        'btn-save-result-ai-edit-in-theme'
      
      ].includes(this.saveButtonClass);
    }
  },
  mounted() {
    this.$nextTick(() => {
      // requires in filebrowser in the Select images modal
      if (this.selectedInstance?.data?.theme) {
        document.getElementById('selected_theme_id').value = this.selectedInstance?.data?.theme;
        document.getElementById('theme').value = this.selectedInstance?.data?.theme;
      }
      
    });
  },
 
 

  methods: {
    warnIfNoThemeSelected() {
      toastr.warning('Theme is not selected');
    },
    downloadFromBrowser() {

      saveSelectionAsEventBroker.fire(EVENTS.SAVE_CROPPED_SELECTION, {
        action: 'download',
        payload: {
          tool: TOOLS_MAPPINGS[this.saveButtonClass] || 'unknown',
          themeId: this.themeSelected,
          fileName: this.fileName,
          imagePath: this.imagePath,
        }
      })
    },
    async saveToTheme() {
      const saveFileName = await this.askUserForFileName();
      if (!saveFileName) {
        //toastr.error('Filename is required.');
        return;
      }
     
      saveSelectionAsEventBroker.fire(EVENTS.SAVE_AS_THEME_IMAGE, {
        action: 'save_to_theme',
        payload: {
          tool: TOOLS_MAPPINGS[this.saveButtonClass] || 'unknown',
          themeId: this.themeSelected,
          templateId: this.selectedInstance.data.template_id,
          customerId: this.selectedInstance.data.customer_id,
          fileName: this.fileName,
          saveFilename: saveFileName,
          imagePath: this.imagePath,
          replaceExistingImage: this.replaceExistingImage,
        }
      })
    },
    askUserForFileName() {
      return new Promise((resolve) => {
        this.tempFileName = this.fileName || '';
        this.resolveFileNamePromise = resolve;
        this.showFilenamePrompt = true;
      });
    },
    confirmFileName() {
      this.showFilenamePrompt = false;
      if (this.resolveFileNamePromise) {
        this.resolveFileNamePromise(this.tempFileName.trim());
      }
    },
    cancelFileName() {
      this.showFilenamePrompt = false;
      if (this.resolveFileNamePromise) {
        this.resolveFileNamePromise(null);
      }
    }
  }
};
</script>

<style scoped lang="scss">
  .text-muted {
    display: block;
    font-size: 10px;
    color: orangered;
  }
  
  ::v-deep a {
    margin: 0 !important;
  }
  .warning {
    cursor: not-allowed;
  }

  .custom-popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2050;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .custom-popup-content {
    background: white;
    padding: 20px;
    border-radius: 6px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    z-index: 2060;
    width: 300px;
  }

  .custom-popup-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    z-index: 2040;
  }
</style>
